<template>
  <el-container class="pagination-list doing-task">
    <el-main>
      <div class="content">
        <el-button class="refresh-button" type="primary" @click="refresh">刷新待办</el-button>
        <el-form :inline="true" :model="process" ref="process" @submit.native.prevent="search" >
          <!--64期晟融流程类型需求-1544-->
          <el-form-item label="流程分类" v-if="tenantId==='16DB9E8F-4B50-003D-9ED7-32C247B72173'">
            <el-select placeholder="请选择流程分类"  v-model="selectedProcess" value-key="name" @change="getTableData" filterable clearable >
            <el-option v-for="item in selectedProcessList" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="关键字" prop="keyword">
            <el-input v-model="process.keyword" placeholder="请输入关键字" clearable/>
          </el-form-item>
          <!--操作按钮-->
          <el-form-item class="process-operation-buttons">
            <el-button @click="search">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table class="table-list" :data="items" v-loading="loading" height="100%" @row-click="rowClick">
          <el-table-column property="instanceName" label="流程信息" align="center" show-overflow-tooltip>
            <template slot-scope="{row}">
              <el-button type="text" class="instance-name">{{row['instanceName']}}</el-button>
            </template>
          </el-table-column>
          <!--64期晟融流程类型需求-1544-->
          <el-table-column property="name" label="流程类型" align="center" v-if="tenantId==='16DB9E8F-4B50-003D-9ED7-32C247B72173'"></el-table-column>
          <el-table-column property="taskName" label="当前节点" align="center"></el-table-column>
          <el-table-column property="taskStartTime" label="到达时间" :formatter="formatDate" align="center"></el-table-column>
          <el-table-column property="started" label="发起人" align="center"></el-table-column>
          <el-table-column property="startedTime" label="发起时间" :formatter="formatDate" align="center"></el-table-column>
          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button class="operation-button" type="text" @click="processTask(scope.row)">处理</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-footer height="32px" class="pagination-footer">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pagination.pageSizes"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          ></el-pagination>
        </el-footer>
      </div>
    </el-main>
    <dialog-form-runtime :formRuntimeDialog="formRuntimeDialog" @goSearch="getTableData"></dialog-form-runtime>
  </el-container>
</template>

<script>
import moment from 'moment'
import DialogFormRuntime from '@/components/shared/dialog-form-runtime.vue'
import CookieOperation from '@/plugins/cookie'
export default {
  name: 'ProcessDoingtasks',
  data () {
    return {
      process: {keyword: ''},
      pagination: {currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0},
      loading: false,
      items: [],
      filters: {},
      selectedProcessList: [],
      selectedProcess: '',
      formRuntimeDialog: {
        visible: false,
        taskId: '',
        width: '',
        title: '处理',
        type: 'process',
        instanceId: '',
        started: '',
        startedTime: ''
      },
      tenantId: '',
      isCreate: false
    }
  },
  components: {
    DialogFormRuntime
  },
  watch: {
    'pagination.currentPage' (val) {
      this.getTableData()
    },
    'pagination.pageSize' (val) {
      this.getTableData()
    }
  },
  async created () {
    this.tenantId = CookieOperation.get('tenantId')
    if (this.tenantId === '16DB9E8F-4B50-003D-9ED7-32C247B72173') {
      await this.loadSelectedProcess()
    }
    this.isCreate = true
    await this.getTableData()
    // 企业微信过来的需要直接打开待办标签页
    if (this.$route.query.isFromQYWXNotice) {
      await this.$axios.get(`/mobile-api/process/processQywxSwitch/${this.$route.query.taskId}`).then(res => {
        // 0 企业微信不可处理 ，1：可处理，2：该流程已被处理或不存在 （要求先判断能否处理，再判断是否被处理）
        if (res.data && res.data.code === '2') {
          this.$message.info('该流程已被处理')
        } else {
          this.processTask({
            taskId: this.$route.query.taskId,
            type: this.$route.query.type === 'process-runtime' ? 'normal' : 'cc'
          })
        }
      })
    }
  },
  methods: {
    // 获取可选择的流程分类名称
    loadSelectedProcess () {
      this.pagination.currentPage = 1
      if (this.tenantId === '16DB9E8F-4B50-003D-9ED7-32C247B72173') {
        this.$axios.get('/process-api/processes/categorys4Shengr').then(res => {
          this.selectedProcessList = res.data
        })
      } else {
        this.$axios.get('/process-api/processes/categorys').then(res => {
          this.selectedProcessList = res.data
        })
      }
    },
    search () {
      this.pagination.currentPage = 1
      this.filters = {
        'keyword': this.process.keyword
      }
      this.getTableData()
    },
    processTask (row) {
      // 如果是知会节点需要禁用流程的全部表单并且只有一个 已阅 按钮
      let type = 'normal'
      this.formRuntimeDialog.type = 'process'
      if (row.type === 'cc') {
        type = 'cc'
        this.formRuntimeDialog.type = 'process-view'
      }
      // 新增一个参数表示从待办跳过去的
      this.formRuntimeDialog.isFromDoingTasks = true
      this.formRuntimeDialog.nodeType = row.type
      this.formRuntimeDialog.taskId = row.taskId
      this.formRuntimeDialog.instanceId = row.instanceId
      this.formRuntimeDialog.started = row.started
      this.formRuntimeDialog.startedTime = row.startedTime
      this.$axios.get(`/process-api/runtime/definitions/${row.taskId}/form/screen`, {params: {
        type: type
      }}).then((res) => {
        this.formRuntimeDialog.width = res.data
        this.formRuntimeDialog.visible = true
      })
    },
    formatDate (row, column) {
      var data = row[column.property]
      if (column.property === 'startedTime') {
        return moment(data).format('YYYY-MM-DD HH:mm')
      }
      return data
    },
    async getTableData () {
      this.loading = true
      let page = this.pagination
      if (this.selectedProcess === '') {
        this.filters = {
          'keyword': this.process.keyword
        }
      } else {
        this.filters = {
          'keyword': this.process.keyword,
          'name': this.selectedProcess
        }
      }
      let params = {
        'index': page.currentPage,
        'size': page.pageSize,
        filters: this.filters
      }
      this.$axios.get('/process-api/runtime/doingTasks/count', {params})
        .then((res) => {
          this.pagination.total = res.data
          // 主页是待办流程需要实时更新待办数量
          let homePage = JSON.parse(sessionStorage.getItem('homepage'))
          if (homePage && homePage[0].name === 'ProcessDoingtasks') {
            this.$emit('updateTodoProcessNum', res.data)
          }
          if ((this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
          }
        })
      await this.$axios.get('/process-api/runtime/doingTasks', {params})
        .then((res) => {
          this.items = res.data
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
    },
    refresh () {
      this.process.keyword = ''
      if (this.pagination.currentPage !== 1) {
        this.pagination.currentPage = 1
      }
      if (this.pagination.pageSize !== 20) {
        this.pagination.pageSize = 20
      }
      this.filters = {
        'keyword': ''
      }
      if (this.tenantId === '16DB9E8F-4B50-003D-9ED7-32C247B72173') {
        this.selectedProcess = ''
      }
      this.getTableData()
    },
    rowClick (row) {
      row && this.processTask(row)
    }
  },
  beforeRouteEnter (to, form, next) {
    next(vm => {
      if (vm.isCreate) {
        vm.isCreate = false
      } else if (!vm.formRuntimeDialog.visible) {
        vm.getTableData()
      }
    })
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/common.scss';
  .doing-task {
    position: relative;
    .refresh-button {
      float: right;
      padding: 5px 7px;
      margin-right: 15px;
    }
    > .el-main {
      > .content {
        .table-list {
          .hover-row {
            cursor: pointer;
            .cell {
              .operation-button {
                &:hover {
                  &::after {
                    background-color: #66b1ff;
                  }
                }
                &:active {
                  &::after {
                    background-color: #3a8ee6;
                  }
                }
              }
              .instance-name {
                position: relative;
                color: #000;
                &::after {
                  content: '';
                  width: 100%;
                  height: 1px;
                  display: inline-block;
                  background-color: var(--primary, #409EFF);
                  position: absolute;
                  bottom: -5px;
                  left: 0;
                }
                span {
                  color: #000;
                }
              }
            }
          }
          .el-table__row {
            .instance-name {
              color: #000;
              font-size: 12px;
              span {
                color: #000;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/process/runtime/process-doingTasks.vue